function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import { INT_TO_ID_MAP } from "./consts";
import AssetComponent from "/components/core/asset/asset-component";
import pickBy from "lodash/pickBy";
import { APPS_NEW, APPS_RECOMMENDED, APPS_TRENDING } from "./consts";
const SHORT_TEXT_TITLE = "Short_text";
const PRODUCTS_TITLE = "Products";
const RELEASE_TYPE_TITLE = "Release_type";
const TEAM_TITLE = "Team";
const RELEASE_STATUS_TITLE = "Release_status";
const PLAN_TITLE = "Plan";
const RELEASE_HIGHLIGHTS_TITLE = "Release_highlights";
const BENEFIT_TITLE = "Benefit";
const DEVICE_TITLE = "Device";
const CLOUDINARY_URL_TITLE = "Cloudinary_image_url";
const ITEM_LOCATION_TITLE = "Location";
const DESKTOP_CLOUDINARY_IMAGE_URL = "Desktop_Cloudinary_image_url";
const ARTICLE_LINK = "Article_link";
const READY_TO_POST = "Ready_to_post";
const MONTHLY_VIDEO_ID = "Monthly_video_id";
const WEBITE_LOCATION_ID = 2;
const getColumnValueByTitle = (item, title)=>{
    var _item_column_values_find;
    const columnValue = (_item_column_values_find = item.column_values.find((columnItem)=>columnItem.column.title === title)) === null || _item_column_values_find === void 0 ? void 0 : _item_column_values_find.value;
    return columnValue ? JSON.parse(columnValue) : null;
};
const formatDate = (dateString, format)=>{
    if (!dateString || dateString === "") {
        return "";
    }
    const date = new Date(dateString);
    if (Number.isNaN(date.getTime())) {
        return "";
    }
    return new Intl.DateTimeFormat("en-US", format).format(date);
};
const getDate = (item, format)=>{
    var _getColumnValueByTitle;
    const dateValue = (_getColumnValueByTitle = getColumnValueByTitle(item, "Date")) === null || _getColumnValueByTitle === void 0 ? void 0 : _getColumnValueByTitle.date;
    return formatDate(dateValue, format) || "";
};
const getFullDate = (item)=>{
    return getDate(item, {
        month: "long",
        day: "numeric",
        year: "numeric"
    });
};
const getMonthYearDate = (item)=>{
    return getDate(item, {
        month: "long",
        year: "numeric"
    });
};
const getPartialDate = (item)=>{
    return getDate(item, {
        month: "long",
        day: "numeric"
    });
};
const getMonthDate = (item)=>{
    return getDate(item, {
        month: "long"
    });
};
const getUrl = (item, title)=>{
    var _getColumnValueByTitle;
    return (_getColumnValueByTitle = getColumnValueByTitle(item, title)) === null || _getColumnValueByTitle === void 0 ? void 0 : _getColumnValueByTitle.replace(/^"|"$/g, "");
};
export const createItemsArray = (items)=>{
    const itemsArray = [];
    const releaseHighlightsArray = [];
    const appsSet = {
        [APPS_NEW]: {
            tabLabel: "New",
            content: []
        },
        [APPS_RECOMMENDED]: {
            tabLabel: "Recommended",
            content: []
        },
        [APPS_TRENDING]: {
            tabLabel: "Trending",
            content: []
        }
    };
    const monthlyVideosSet = new Map();
    items === null || items === void 0 ? void 0 : items.forEach((item)=>{
        var _item_column_values_find_value, _item_column_values_find, _item_column_values, _getColumnValueByTitle, _getColumnValueByTitle1, _getColumnValueByTitle2, _getColumnValueByTitle3;
        const title = item === null || item === void 0 ? void 0 : (_item_column_values = item.column_values) === null || _item_column_values === void 0 ? void 0 : (_item_column_values_find = _item_column_values.find((columnItem)=>columnItem.column.title === "title")) === null || _item_column_values_find === void 0 ? void 0 : (_item_column_values_find_value = _item_column_values_find.value) === null || _item_column_values_find_value === void 0 ? void 0 : _item_column_values_find_value.replace(/"/g, "");
        const shortText = ((_getColumnValueByTitle = getColumnValueByTitle(item, SHORT_TEXT_TITLE)) === null || _getColumnValueByTitle === void 0 ? void 0 : _getColumnValueByTitle.text) || "";
        const releaseTypeIndex = (_getColumnValueByTitle1 = getColumnValueByTitle(item, RELEASE_TYPE_TITLE)) === null || _getColumnValueByTitle1 === void 0 ? void 0 : _getColumnValueByTitle1.index;
        const releaseType = INT_TO_ID_MAP.releaseType[releaseTypeIndex];
        const planIndex = (_getColumnValueByTitle2 = getColumnValueByTitle(item, PLAN_TITLE)) === null || _getColumnValueByTitle2 === void 0 ? void 0 : _getColumnValueByTitle2.index;
        const plan = INT_TO_ID_MAP.plan[planIndex];
        const fullDate = getFullDate(item);
        const monthYearDate = getMonthYearDate(item);
        const partialDate = getPartialDate(item);
        const monthDate = getMonthDate(item);
        const locationIndices = (_getColumnValueByTitle3 = getColumnValueByTitle(item, ITEM_LOCATION_TITLE)) === null || _getColumnValueByTitle3 === void 0 ? void 0 : _getColumnValueByTitle3.ids;
        const isWebsiteLocation = locationIndices === null || locationIndices === void 0 ? void 0 : locationIndices.includes(WEBITE_LOCATION_ID);
        const monthlyVideoId = getUrl(item, MONTHLY_VIDEO_ID);
        if (monthlyVideoId) {
            monthlyVideosSet.set(monthYearDate, monthlyVideoId);
        }
        const readyToPost = getColumnValueByTitle(item, READY_TO_POST);
        if (!readyToPost || readyToPost.index !== 105) {
            return;
        }
        const isValid = title && shortText && releaseType && fullDate && isWebsiteLocation;
        if (isValid) {
            var _getColumnValueByTitle_ids, _getColumnValueByTitle4, _getColumnValueByTitle5, _getColumnValueByTitle6, _getColumnValueByTitle7, _getColumnValueByTitle8, _getColumnValueByTitle9, _getColumnValueByTitle10;
            const productIndex = (_getColumnValueByTitle4 = getColumnValueByTitle(item, PRODUCTS_TITLE)) === null || _getColumnValueByTitle4 === void 0 ? void 0 : (_getColumnValueByTitle_ids = _getColumnValueByTitle4.ids) === null || _getColumnValueByTitle_ids === void 0 ? void 0 : _getColumnValueByTitle_ids[0];
            const teamIndex = (_getColumnValueByTitle5 = getColumnValueByTitle(item, TEAM_TITLE)) === null || _getColumnValueByTitle5 === void 0 ? void 0 : _getColumnValueByTitle5.index;
            const releaseStatusIndex = (_getColumnValueByTitle6 = getColumnValueByTitle(item, RELEASE_STATUS_TITLE)) === null || _getColumnValueByTitle6 === void 0 ? void 0 : _getColumnValueByTitle6.index;
            const releaseHighlightsIndex = (_getColumnValueByTitle7 = getColumnValueByTitle(item, RELEASE_HIGHLIGHTS_TITLE)) === null || _getColumnValueByTitle7 === void 0 ? void 0 : _getColumnValueByTitle7.index;
            const benefitIndices = (_getColumnValueByTitle8 = getColumnValueByTitle(item, BENEFIT_TITLE)) === null || _getColumnValueByTitle8 === void 0 ? void 0 : _getColumnValueByTitle8.ids;
            const deviceIndices = (_getColumnValueByTitle9 = getColumnValueByTitle(item, DEVICE_TITLE)) === null || _getColumnValueByTitle9 === void 0 ? void 0 : _getColumnValueByTitle9.ids;
            const articleLink = ((_getColumnValueByTitle10 = getColumnValueByTitle(item, ARTICLE_LINK)) === null || _getColumnValueByTitle10 === void 0 ? void 0 : _getColumnValueByTitle10.url) || "";
            const product = INT_TO_ID_MAP.product[productIndex];
            const team = INT_TO_ID_MAP.team[teamIndex];
            const releaseStatus = INT_TO_ID_MAP.releaseStatus[releaseStatusIndex];
            const cloudinaryUrl = getUrl(item, CLOUDINARY_URL_TITLE);
            const desktopCloudinaryUrl = getUrl(item, DESKTOP_CLOUDINARY_IMAGE_URL);
            const isReleaseHighlight = INT_TO_ID_MAP.releaseHeighlights[releaseHighlightsIndex];
            const benefit = benefitIndices ? benefitIndices.map((benefitIndex)=>INT_TO_ID_MAP.benefit[benefitIndex]) : [];
            const device = deviceIndices ? deviceIndices.map((deviceIndex)=>INT_TO_ID_MAP.device[deviceIndex]) : [];
            const newItem = {
                title,
                shortText,
                product,
                releaseType,
                team,
                releaseStatus,
                plan,
                benefit,
                device,
                cloudinaryUrl,
                desktopCloudinaryUrl,
                articleLink,
                fullDate,
                partialDate,
                monthDate,
                monthYearDate
            };
            if (releaseType === APPS_NEW || releaseType === APPS_RECOMMENDED || releaseType === APPS_TRENDING) {
                var _appsSet_releaseType_content, _appsSet_releaseType;
                (_appsSet_releaseType = appsSet[releaseType]) === null || _appsSet_releaseType === void 0 ? void 0 : (_appsSet_releaseType_content = _appsSet_releaseType.content) === null || _appsSet_releaseType_content === void 0 ? void 0 : _appsSet_releaseType_content.push(newItem);
                return;
            }
            itemsArray.push(newItem);
            if (isReleaseHighlight && isValid) {
                releaseHighlightsArray.push(newItem);
            }
        }
    });
    return {
        itemsArray,
        releaseHighlightsArray,
        monthlyVideosSet,
        appsSet
    };
};
export const filterItems = (items, filters, textSearch)=>{
    return items.filter((item)=>{
        var _item_title_toLowerCase, _item_title, _item_description_toLowerCase, _item_description;
        return Object.entries(filters).every(([id, filter])=>{
            if (Array.isArray(item[id])) {
                return filter === [] || filter.length === 0 || item[id].some((value)=>filter.includes(value));
            }
            return filter === [] || filter.length === 0 || filter.includes(item[id]);
        }) && (textSearch === "" || (item === null || item === void 0 ? void 0 : (_item_title = item.title) === null || _item_title === void 0 ? void 0 : (_item_title_toLowerCase = _item_title.toLowerCase()) === null || _item_title_toLowerCase === void 0 ? void 0 : _item_title_toLowerCase.includes(textSearch.toLowerCase())) || (item === null || item === void 0 ? void 0 : (_item_description = item.description) === null || _item_description === void 0 ? void 0 : (_item_description_toLowerCase = _item_description.toLowerCase()) === null || _item_description_toLowerCase === void 0 ? void 0 : _item_description_toLowerCase.includes(textSearch.toLowerCase())));
    });
};
export const getReleaseTypeIcon = (releaseType)=>{
    const releaseTypeIconMap = {
        New_release: "https://dapulse-res.cloudinary.com/image/upload/c_thumb,w_200,g_face/Generator_featured%20images/Whats%20new%20page/release%20type%20icons/feature_release_icon.svg",
        Bug_fix: "https://dapulse-res.cloudinary.com/image/upload/c_thumb,w_200,g_face/Generator_featured%20images/Whats%20new%20page/release%20type%20icons/bug_fix_icon.svg",
        Performance: "https://dapulse-res.cloudinary.com/image/upload/c_thumb,w_200,g_face/Generator_featured%20images/Whats%20new%20page/release%20type%20icons/performance_icon2.svg",
        Event: "https://dapulse-res.cloudinary.com/image/upload/c_thumb,w_200,g_face/Generator_featured%20images/Whats%20new%20page/release%20type%20icons/event_icon.svg",
        Announcement: "https://dapulse-res.cloudinary.com/image/upload/c_thumb,w_200,g_face/Generator_featured%20images/Whats%20new%20page/release%20type%20icons/announcement_icon.svg",
        Feature_upgrade: "https://dapulse-res.cloudinary.com/image/upload/c_thumb,w_200,g_face/Generator_featured%20images/Whats%20new%20page/release%20type%20icons/new_feature_upgrade_icon.svg",
        Apps_and_integrations: "https://dapulse-res.cloudinary.com/image/upload/c_thumb,w_200,g_face/Generator_featured%20images/Whats%20new%20page/release%20type%20icons/new_apps_integration_icon.svg",
        Gradual_release: "https://dapulse-res.cloudinary.com/image/upload/c_thumb,w_200,g_face/Generator_featured%20images/Whats%20new%20page/release%20type%20icons/sprout.svg"
    };
    return Object.keys(releaseTypeIconMap).includes(releaseType) ? /*#__PURE__*/ _jsx("div", {
        className: "icon",
        children: /*#__PURE__*/ _jsx(AssetComponent, {
            image: {
                src: releaseTypeIconMap[releaseType]
            }
        })
    }) : null;
};
export const getFilterIcon = (name)=>{
    const filterIconMap = {
        "CRM": /*#__PURE__*/ _jsx(AssetComponent, {
            image: {
                src: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/Whats%20new%20page/products%20icons/crm.svg"
            }
        }),
        Dev: /*#__PURE__*/ _jsx(AssetComponent, {
            image: {
                src: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/Whats%20new%20page/products%20icons/dev.svg"
            }
        }),
        WorkCanvas: /*#__PURE__*/ _jsx(AssetComponent, {
            image: {
                src: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/Homepage%20-%202024/canvas.png"
            }
        }),
        WorkForms: /*#__PURE__*/ _jsx(AssetComponent, {
            image: {
                src: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/Whats%20new%20page/products%20icons/workforms.svg"
            }
        }),
        "Work Management": /*#__PURE__*/ _jsx(AssetComponent, {
            image: {
                src: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/Whats%20new%20page/products%20icons/wm.svg"
            }
        })
    };
    return Object.keys(filterIconMap).includes(name) ? /*#__PURE__*/ _jsx("div", {
        className: "icon",
        children: filterIconMap[name]
    }) : null;
};
export const getCleanedFilterSchema = (filtersSchema, itemsArray)=>{
    // clean options in filters if there are no items
    return filtersSchema.map((filterSchemaItem)=>_object_spread_props(_object_spread({}, filterSchemaItem), {
            data: pickBy(filterSchemaItem.data, (value, key)=>{
                const filterSchemeItemIds = [
                    ...new Set(itemsArray.map((item)=>item[filterSchemaItem.id]))
                ];
                // have all options for benefit
                return filterSchemaItem.id === "benefit" || filterSchemeItemIds.includes(key);
            })
        }))// clean filters with only 1 or less option within
    .filter((filter)=>Object.keys(filter.data).length > 1);
};
export const PRODUCT_TAG_TYPE = "product";
export const RELEASE_TYPE_TAG_TYPE = "releaseType";
export const TEAM_TAG_TYPE = "team";
export const RELEASE_STATUS_TAG_TYPE = "releaseStatus";
export const PLAN_TAG_TYPE = "plan";
export const BENEFIT_TAG_TYPE = "benefit";
export const DEVICE_TAG_TYPE = "device";
